import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import Teams from "./Tabs/team";
import TeamDetail from "./Tabs/teamdetail";
import CheckEquipment from "./Tabs/CheckEquipment";
import CheckJobdetail from "./Tabs/CheckJobdetail";
import WorkCalendar from "../JobAcceptance/Tabs/calendar";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import { useAlert } from "../../../context/AlertContext";
import JobTypeService from "../../../services/jobtype.service";
import { filteredNoneMultiItemInArray } from "../../../utils/ManageArray";

export default function JobAcceptanceTeam() {
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [defaultData, setDefaultData] = useState(
    {
      tech_name: "",
      team: "",
      job_type: []
    }
  );

  useEffect(() => {
    handleChangeTab(state?.name || "acceptance");
  }, []);

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        acceptance: "ทีมงานรับงาน",
        JobDetails: "ข้อมูลการรับงาน",
        CheckEquipment: "ตรวจรับอุปกรณ์/อะไหล่",
        CheckJobDetails: "ตรวจสอบรายละเอียดงาน",
        EventplaningCalendar: "ปฏิทินงานช่าง",
      }
    });
  };

  useEffect(() => {
    initData()
  }, [])

  function initData() {

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeService.getJobTypesForTechPlan(),
      callback: (res) => setDefaultData({
        ...defaultData,
        job_type: (filteredNoneMultiItemInArray(res, "Id"))
      })
    });
  }

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0" id="tab_team">
        <Tabs
          justify
          defaultActiveKey={state?.name || "acceptance"}
          onSelect={handleChangeTab}
          className="mb-3"
        >
          <Tab eventKey="acceptance" title="ทีมงานรับงาน">
            {websiteName === "ทีมงานรับงาน" && <Teams defaultData={defaultData} />}
          </Tab>
          <Tab eventKey="JobDetails" title="ข้อมูลการรับงาน">
            {websiteName === "ข้อมูลการรับงาน" && <TeamDetail defaultData={defaultData} />}
          </Tab>
          <Tab eventKey="CheckEquipment" title="ตรวจรับอุปกรณ์/อะไหล่">
            {websiteName === "ตรวจรับอุปกรณ์/อะไหล่" && <CheckEquipment defaultData={defaultData} />}
          </Tab>
          <Tab eventKey="CheckJobDetails" title="ตรวจสอบรายละเอียดงาน">
            {websiteName === "ตรวจสอบรายละเอียดงาน" && <CheckJobdetail defaultData={defaultData} />}
          </Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง">
            {websiteName === "ปฏิทินงานช่าง" && <WorkCalendar defaultData={defaultData} />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
